import { isSupportedOpenExternalBrowser, openExternalBrowser } from '@common/utils';

import { dialogOnlyForApp } from './dialog-only-for-app';
import { getWebLinkFrom } from './get-web-link-from';

export function redirectToLandingUrl({ isZigzagApp, landing_url }: { isZigzagApp: boolean; landing_url: string }) {
  if (isZigzagApp) {
    const is_website = landing_url.startsWith('https://');
    if (is_website && isSupportedOpenExternalBrowser()) {
      openExternalBrowser(landing_url);
      return;
    }
    return window.location.assign(landing_url);
  }

  const destination = getWebLinkFrom({ deeplink: landing_url });
  const is_deeplink = destination.includes('zigzag://');

  if (is_deeplink) {
    dialogOnlyForApp({ deepLinkUrl: destination });
    return;
  }

  return window.open(destination, '_blank');
}
